const fixFormat = Intl.NumberFormat('es-MX', { 
  style: 'currency', 
  currency: 'MXN', 
  minimumFractionDigits: 2
})
export const columns = [
  {
    Header: "Nombre",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) => row.name?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Total",
    accessor: "totalCommission",
    filterable: true,
    Cell: props => props.value != null ? fixFormat.format(props.value) : null,
    filterMethod: (filter, row) => row.totalCommission?.toString().toLowerCase().includes(filter.value.toLowerCase())
  },
];